import { AxiosInstance } from 'axios';
import { getWithAuth } from '../InitializeService';
import { buildODataQuery, ODataParams } from '@/utils/odataUtil';
export const getRegionsWithFilters = (params: ODataParams, instance: AxiosInstance) => {
    return getWithAuth(`regions${buildODataQuery(params)}` ,instance);
}